/* Campaign attribution for the beta forms (owner 2026-11-04).
 *
 * Records the visitor's FIRST and LAST touch — utm_* values, the ad network of a click id
 * (gclid/gbraid/wbraid → google, fbclid → meta, msclkid → microsoft, ttclid → tiktok), the
 * external referrer host and the landing path — in localStorage for 90 days, and exposes
 * window.ArterielAttribution.get() for the forms (join-partner.js, the trade apply page).
 *
 * Consent: stored ONLY when Shopify's Customer Privacy API says marketing is allowed
 * (customerPrivacy.marketingAllowed()). Consent refused ⇒ any stored record is removed.
 * No API (or it fails) ⇒ nothing is stored (fails closed). A consent answer later in the
 * same page view (visitorConsentCollected) stores this page's touch then.
 * The connector cleans every value again (app/forms/attribution.ts).
 */
(function () {
  "use strict";
  var KEY = "arteriel-attr-v1";
  var TTL_MS = 90 * 864e5;
  var UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var CLICK = [["gclid", "google"], ["gbraid", "google"], ["wbraid", "google"], ["fbclid", "meta"], ["msclkid", "microsoft"], ["ttclid", "tiktok"]];
  var allowed = false;

  function load() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || "null");
      if (v && v.first && Date.now() - Date.parse(v.first.at) < TTL_MS) return v;
    } catch (e) { /* unreadable: start again */ }
    return null;
  }

  function touch() {
    var q = new URLSearchParams(window.location.search);
    var t = {};
    UTM.forEach(function (k) { var v = q.get(k); if (v) t[k] = v.slice(0, 100); });
    for (var i = 0; i < CLICK.length; i++) { if (q.get(CLICK[i][0])) { t.click = CLICK[i][1]; break; } }
    var ref = "";
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      if (r && r.hostname && r.hostname !== window.location.hostname) ref = r.hostname;
    } catch (e) { ref = ""; }
    if (!Object.keys(t).length && !ref) return null;  // an internal page view or a direct visit
    if (ref) t.referrer = ref;
    t.landing = window.location.pathname.slice(0, 120);
    t.at = new Date().toISOString();
    return t;
  }

  var current = touch();

  function apply() {
    try {
      if (!allowed) { window.localStorage.removeItem(KEY); return; }
      if (!current) return;
      var v = load() || { first: current };
      v.last = current;
      window.localStorage.setItem(KEY, JSON.stringify(v));
    } catch (e) { /* storage blocked: nothing to do */ }
  }

  function check() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try { allowed = !!(cp && typeof cp.marketingAllowed === "function" && cp.marketingAllowed()); } catch (e) { allowed = false; }
    apply();
  }

  window.ArterielAttribution = {
    get: function () { return allowed ? load() : null; },
  };

  var S = window.Shopify;
  if (!S || typeof S.loadFeatures !== "function") return;  // no consent API: store nothing
  try {
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err) return;
      check();
      document.addEventListener("visitorConsentCollected", check);
    });
  } catch (e) { /* API failure: store nothing */ }
})();
